var map = {
	"./4FriendsP4/babyHand.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/4FriendsP4/babyHand.svg",
	"./4FriendsP4/dollHand.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/4FriendsP4/dollHand.svg",
	"./4FriendsP4/fourFeet.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/4FriendsP4/fourFeet.svg",
	"./4FriendsP4/kopilaHand.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/4FriendsP4/kopilaHand.svg",
	"./4FriendsP4/teddyHand.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/4FriendsP4/teddyHand.svg",
	"./FriendsP5/frontBoy.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/FriendsP5/frontBoy.gif",
	"./FriendsP5/frontBoy.png": "./src/EGRContent/Story/BagBhariKoRahar/images/FriendsP5/frontBoy.png",
	"./FriendsP5/frontGirl.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/FriendsP5/frontGirl.gif",
	"./FriendsP5/frontGirl.png": "./src/EGRContent/Story/BagBhariKoRahar/images/FriendsP5/frontGirl.png",
	"./FriendsP5/kopila_sad_girl.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/FriendsP5/kopila_sad_girl.gif",
	"./_.png": "./src/EGRContent/Story/BagBhariKoRahar/images/_.png",
	"./bag-flower.png": "./src/EGRContent/Story/BagBhariKoRahar/images/bag-flower.png",
	"./bag.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/bag.svg",
	"./bagItems.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/bagItems.svg",
	"./bag_with_books.png": "./src/EGRContent/Story/BagBhariKoRahar/images/bag_with_books.png",
	"./bag_with_flower-p10.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/bag_with_flower-p10.gif",
	"./bag_with_flower_page10.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/bag_with_flower_page10.gif",
	"./box_01.png": "./src/EGRContent/Story/BagBhariKoRahar/images/box_01.png",
	"./box_01_page01.png": "./src/EGRContent/Story/BagBhariKoRahar/images/box_01_page01.png",
	"./box_02_page01.png": "./src/EGRContent/Story/BagBhariKoRahar/images/box_02_page01.png",
	"./box_page02.png": "./src/EGRContent/Story/BagBhariKoRahar/images/box_page02.png",
	"./cover_page.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/cover_page.svg",
	"./four_friend_page04.png": "./src/EGRContent/Story/BagBhariKoRahar/images/four_friend_page04.png",
	"./four_kids_page03.png": "./src/EGRContent/Story/BagBhariKoRahar/images/four_kids_page03.png",
	"./friend-bottom-p6.png": "./src/EGRContent/Story/BagBhariKoRahar/images/friend-bottom-p6.png",
	"./friend-top-p6.png": "./src/EGRContent/Story/BagBhariKoRahar/images/friend-top-p6.png",
	"./girl_head_page07.png": "./src/EGRContent/Story/BagBhariKoRahar/images/girl_head_page07.png",
	"./girl_page02.png": "./src/EGRContent/Story/BagBhariKoRahar/images/girl_page02.png",
	"./girl_page03.png": "./src/EGRContent/Story/BagBhariKoRahar/images/girl_page03.png",
	"./girl_standing.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/girl_standing.svg",
	"./girl_washing_dish.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/girl_washing_dish.gif",
	"./hugging/Body.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/hugging/Body.svg",
	"./hugging/heart.png": "./src/EGRContent/Story/BagBhariKoRahar/images/hugging/heart.png",
	"./hugging/kopilaHead.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/hugging/kopilaHead.svg",
	"./hugging/mumHead.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/hugging/mumHead.svg",
	"./hugging/page14.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/hugging/page14.svg",
	"./img_page09.png": "./src/EGRContent/Story/BagBhariKoRahar/images/img_page09.png",
	"./img_page09_a.png": "./src/EGRContent/Story/BagBhariKoRahar/images/img_page09_a.png",
	"./img_page09_b.png": "./src/EGRContent/Story/BagBhariKoRahar/images/img_page09_b.png",
	"./kopila_on_bed.png": "./src/EGRContent/Story/BagBhariKoRahar/images/kopila_on_bed.png",
	"./kopila_put_book_to_bag.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/kopila_put_book_to_bag.gif",
	"./kopila_put_book_to_bag.png": "./src/EGRContent/Story/BagBhariKoRahar/images/kopila_put_book_to_bag.png",
	"./mum_hand.png": "./src/EGRContent/Story/BagBhariKoRahar/images/mum_hand.png",
	"./mum_sad.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/mum_sad.gif",
	"./outline-lg-white.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-lg-white.png",
	"./outline-p10-white.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-p10-white.png",
	"./outline-p4-white.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-p4-white.png",
	"./outline-p4-white2.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-p4-white2.png",
	"./outline-p4-white3.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-p4-white3.png",
	"./outline-p6-white.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-p6-white.png",
	"./outline-sm-white.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-sm-white.png",
	"./outline-sm-white2.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-sm-white2.png",
	"./outline-sm-white3.png": "./src/EGRContent/Story/BagBhariKoRahar/images/outline-sm-white3.png",
	"./page06.svg": "./src/EGRContent/Story/BagBhariKoRahar/images/page06.svg",
	"./page07a.png": "./src/EGRContent/Story/BagBhariKoRahar/images/page07a.png",
	"./page07b.png": "./src/EGRContent/Story/BagBhariKoRahar/images/page07b.png",
	"./page11_stich.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/page11_stich.gif",
	"./page18.png": "./src/EGRContent/Story/BagBhariKoRahar/images/page18.png",
	"./page18_bag.png": "./src/EGRContent/Story/BagBhariKoRahar/images/page18_bag.png",
	"./sad-kopila-walk.png": "./src/EGRContent/Story/BagBhariKoRahar/images/sad-kopila-walk.png",
	"./star.png": "./src/EGRContent/Story/BagBhariKoRahar/images/star.png",
	"./stich_page11.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/stich_page11.gif",
	"./swipingGirl.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/swipingGirl.gif",
	"./text_banner.png": "./src/EGRContent/Story/BagBhariKoRahar/images/text_banner.png",
	"./thumbnail.png": "./src/EGRContent/Story/BagBhariKoRahar/images/thumbnail.png",
	"./toy_page02.gif": "./src/EGRContent/Story/BagBhariKoRahar/images/toy_page02.gif",
	"./wavingBook/page18_hand.png": "./src/EGRContent/Story/BagBhariKoRahar/images/wavingBook/page18_hand.png",
	"./wavingBook/page18_kopila.png": "./src/EGRContent/Story/BagBhariKoRahar/images/wavingBook/page18_kopila.png",
	"./wavingBook/page18a.png": "./src/EGRContent/Story/BagBhariKoRahar/images/wavingBook/page18a.png",
	"./wavingBook/t_shirt.png": "./src/EGRContent/Story/BagBhariKoRahar/images/wavingBook/t_shirt.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/BagBhariKoRahar/images sync recursive ^\\.\\/.*$";